// @ts-check

/**
 * @param {string} route
 * @returns {string}
 */
export function normalizeRoutePath(route) {
  const trimmedRoute = route.trim();
  if (trimmedRoute === "" || trimmedRoute === "/index.html") {
    return "/";
  }

  let normalizedRoute = trimmedRoute;
  if (!normalizedRoute.startsWith("/")) {
    normalizedRoute = `/${normalizedRoute}`;
  }

  if (normalizedRoute.length > 1 && normalizedRoute.endsWith("/")) {
    normalizedRoute = normalizedRoute.slice(0, -1);
  }

  return normalizedRoute;
}

function addRouterEventListeners() {
  window.addEventListener("popstate", function (event) {
    const routeFromState = event.state?.route;
    const routeText = typeof routeFromState === "string"
      ? routeFromState
      : window.location.pathname;
    const route = normalizeRoutePath(routeText);
    Router.go(route, false);
  });

  document.body.addEventListener("click", function (event) {
    if (!(event instanceof MouseEvent)) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const matchedElement = target.closest("[data-router]");
    if (!(matchedElement instanceof HTMLElement)) {
      return;
    }

    const destinationFromDataset = matchedElement.dataset.destination || "";
    const destinationFromHref = matchedElement.getAttribute("href") || "";
    const destination = destinationFromDataset || destinationFromHref;
    if (!destination.startsWith("/")) {
      return;
    }

    if (matchedElement.getAttribute("target") === "_blank") {
      return;
    }

    event.preventDefault();
    Router.go(destination);
  });
}

export const Router = {
  init: function () {
    addRouterEventListeners();
    const route = normalizeRoutePath(window.location.pathname);
    history.replaceState({ route }, "", route);
  },
  /**
   * @param {string} route
   * @param {boolean} [addToHistory=true]
   * @returns {void}
   */
  go: function (route, addToHistory = true) {
    const normalizedRoute = normalizeRoutePath(route);
    if (addToHistory) {
      history.pushState({ route: normalizedRoute }, "", normalizedRoute);
    } else {
      history.replaceState({ route: normalizedRoute }, "", normalizedRoute);
    }

    window.dispatchEvent(
      new CustomEvent("app:navigate", { detail: { path: normalizedRoute } }),
    );
    window.scrollTo(0, 0);
  },
};
